import { useContext } from "react";
import { AppPreferencesContext } from "../../General/AppPreferencesContext";
import {
  filterTypes,
  type SavedFilterType,
} from "../../Findings/FindingsUtils";
import { filterEntityEnum, type FilterEntity } from "./filterEntity";

const savedFilterTypeByFilterEntity: Partial<
  Record<FilterEntity, SavedFilterType>
> = {
  [filterEntityEnum.REMEDIATION_ITEM]: filterTypes.REMEDIATION_ITEM_FILTER,
  [filterEntityEnum.SEEMPLICITY_FINDING]:
    filterTypes.SEEMPLICITY_FINDING_FILTER,
};

const getEntitySavedFilterType = (
  entity: FilterEntity | null | undefined
): SavedFilterType | undefined =>
  entity ? savedFilterTypeByFilterEntity[entity] : undefined;

export const resolveSavedFilterType = (
  entity: FilterEntity | null | undefined,
  isOpenSeemplicityFindings: boolean
): SavedFilterType =>
  (isOpenSeemplicityFindings ? getEntitySavedFilterType(entity) : undefined) ??
  filterTypes.FILTER;

export interface UseSavedFilterTypeStateReturnValue {
  savedFilterType: SavedFilterType;
  isSavedFilterTypeKnown: boolean;
  supportsSavedFilters: boolean;
}

export const useSavedFilterTypeState = (
  entity: FilterEntity | null | undefined
): UseSavedFilterTypeStateReturnValue => {
  const { openSeemplicityFindings } = useContext(AppPreferencesContext);
  const entitySavedFilterType = getEntitySavedFilterType(entity);

  return {
    savedFilterType: resolveSavedFilterType(
      entity,
      openSeemplicityFindings === true
    ),
    isSavedFilterTypeKnown:
      openSeemplicityFindings !== undefined || !entitySavedFilterType,
    supportsSavedFilters: !entity || !!entitySavedFilterType,
  };
};

const useSavedFilterType = (
  entity: FilterEntity | null | undefined
): SavedFilterType => useSavedFilterTypeState(entity).savedFilterType;

export default useSavedFilterType;
